export  const ak = "AIzaSyDrGswFwMniOx8tkYIz3M2L8m8pGSVSWj8";